export function rutFormater(val) {
  var res = val;
  const length = val.length;
  if (length > 3) {
    res = res.substring(0, length - 3) + '.' + res.substring(length - 3, length);
  }
  if (length > 6) {
    res = res.substring(0, length - 6) + '.' + res.substring(length - 6, length + 1);
  }

  return res;
}
